import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDelete = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "#6d0fa7",
	height: 16,
	viewBox: "0 0 24 24",
	width: 16,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "m10 2-1 1h-6v2h18v-2h-6l-1-1zm-5.6347656 5 1.5273437 13.263672c.132.99.9844219 1.736328 1.9824219 1.736328h8.248047c.998 0 1.851375-.745141 1.984375-1.744141l1.527344-13.255859z" })
});
export { SvgDelete as ReactComponent };
